/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_CreateInputs */

const en_settings_apikeys_create = /** @type {(inputs: Settings_Apikeys_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const zh_settings_apikeys_create = /** @type {(inputs: Settings_Apikeys_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Settings_Apikeys_CreateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_create = /** @type {((inputs?: Settings_Apikeys_CreateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_CreateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_create(inputs)
	return zh_settings_apikeys_create(inputs)
});
export { settings_apikeys_create as "settings.apikeys.create" }